export default __webpack_public_path__ + "static/iconsGruop-e850469d7d6cf83c6d1bd03a5fac75ad.jpg";